import { collection, doc, getDocs, addDoc, updateDoc, query, where } from "firebase/firestore";
import { db } from "../config/firebase";

const COLLECTION = "namHoc";
const COLLECTION_KY = "kyDanhGia";

// ===== NĂM HỌC =====
export const getNamHocActive = async () => {
  const q = query(collection(db, COLLECTION), where("trangThai", "==", "dangHoatDong"));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))[0] || null;
};

export const getAllNamHoc = async () => {
  const snapshot = await getDocs(collection(db, COLLECTION));
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const createNamHoc = async (data) => {
  await addDoc(collection(db, COLLECTION), { ...data, ngayTao: new Date().toISOString() });
};

export const ketThucNamHoc = async (id) => {
  await updateDoc(doc(db, COLLECTION, id), { trangThai: 'ketThuc', ngayKetThuc: new Date().toISOString() });
};

// ===== HỌC KỲ =====
export const getActiveHocKy = async () => {
  const today = new Date().toISOString().split('T')[0];
  const snap = await getDocs(collection(db, COLLECTION_KY));
  
  for (const docSnap of snap.docs) {
    const ky = docSnap.data();
    if (today >= ky.ngayBatDau && today <= ky.ngayKetThuc) {
      return { id: docSnap.id, ...ky };
    }
  }
  // Fallback
  return { hocKy: 'HK1', namHoc: '2025-2026', ngayBatDau: '2025-08-01', ngayKetThuc: '2025-12-31' };
};

export const getAllKyDanhGia = async () => {
  const snap = await getDocs(collection(db, COLLECTION_KY));
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};